module.exports = __webpack_public_path__ + "img/LauterAlsDasWasser.5dd499eb.svg";